import { h } from 'preact';
import { GiftboxProduct } from '../giftbox-product';
import { GiftboxGroupTab } from '../giftbox-group-tab';
import { t } from '../../../theme/locales';
const StepChooseGiftbox = ({ state , setState , giftboxProducts =null , diyGiftboxProducts =null , hideComplimentaryMessage =false  })=>{
    const assembledProducts = giftboxProducts ? Object.entries(giftboxProducts) : [];
    const diyProducts = diyGiftboxProducts ? Object.entries(diyGiftboxProducts) : [];
    var _state_giftboxGroup;
    const activeGroup = (_state_giftboxGroup = state.giftboxGroup) !== null && _state_giftboxGroup !== void 0 ? _state_giftboxGroup : assembledProducts.length > 0 ? 'assembled' : diyProducts.length > 0 ? 'diy' : 'message';
    const setGroup = (group)=>{
        setState({
            giftboxGroup: group,
            giftbox: '',
            variant: '',
            items: [],
            isDiy: group === 'diy'
        });
    };
    const renderProduct = (handle, product, isDiy)=>h(GiftboxProduct, {
            key: handle,
            handle,
            product,
            state,
            setState,
            isDiy
        });
    const renderProducts = (products, isDiy)=>h('div', {
            className: 'giftbox-group__products'
        }, [
            h('div', {
                className: 'giftbox-group__title'
            }, t('gift_wrapping.steps.choose_giftbox.product_list_title')),
            h('div', {
                className: 'giftbox-group__options'
            }, products.map(([handle, product])=>renderProduct(handle, product, isDiy)))
        ]);
    if (!assembledProducts.length && !diyProducts.length) {
        return h('div', {}, t('gift_wrapping.steps.choose_giftbox.no_giftboxes'));
    }
    return h('div', {
        className: 'giftbox-groups',
        'data-testid': 'gift-wrapping-giftbox-groups',
        role: 'radiogroup',
        'aria-label': t('gift_wrapping.steps.choose_giftbox.group_label')
    }, [
        assembledProducts.length > 0 ? h(GiftboxGroupTab, {
            value: 'assembled',
            activeGroup,
            title: t('gift_wrapping.group_tabs.assembled.title', ''),
            description: t('gift_wrapping.group_tabs.assembled.description', ''),
            price: null,
            onSelect: setGroup
        }, renderProducts(assembledProducts, false)) : null,
        diyProducts.length > 0 ? h(GiftboxGroupTab, {
            value: 'diy',
            activeGroup,
            title: t('gift_wrapping.group_tabs.diy.title', ''),
            description: t('gift_wrapping.group_tabs.diy.description', ''),
            price: null,
            onSelect: setGroup
        }, renderProducts(diyProducts, true)) : null,
        !hideComplimentaryMessage ? h(GiftboxGroupTab, {
            value: 'message',
            activeGroup,
            title: t('gift_wrapping.group_tabs.complimentary_message.title'),
            description: t('gift_wrapping.group_tabs.complimentary_message.description'),
            price: null,
            onSelect: setGroup
        }) : null
    ]);
};
export default StepChooseGiftbox;
